export enum Rule {
  Dirty = 'dirty',
  Touched = 'touched',
}

export class ValidationConfiguration {
  public readonly defaultRules: Rule[] = [Rule.Dirty, Rule.Touched];
}
